<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 132 131">
    <g :fill="color" fill-rule="nonzero">
      <g :fill="color" fill-rule="nonzero">
        <path
          d="M70.062.322H73.108V3.387H70.062zM77.575.322H80.62100000000001V3.387H77.575zM84.886.322H87.932V3.387H84.886zM92.4.322H95.44600000000001V3.387H92.4zM23.557 98.804v14.302c-12.997-11.85-20.51-28.604-20.51-46.584 0-34.939 28.227-63.135 62.75-63.135V.322C29.447.322 0 29.95 0 66.522c0 18.593 7.717 35.96 21.12 48.423H7.717v3.065h19.09V98.804h-3.25zM110.88 16.055h13.403V12.99h-19.09v19.206h3.047V17.894c13.2 11.85 20.714 28.604 20.714 46.584 0 34.939-28.228 63.135-62.75 63.135v3.065c36.35 0 65.796-29.627 65.796-66.2 0-18.593-7.717-35.96-21.12-48.423zM58.892 127.613H61.938V130.678H58.892zM51.378 127.613H54.424V130.678H51.378zM44.068 127.613H47.114V130.678H44.068zM36.554 127.613H39.6V130.678H36.554z"
          transform="translate(-657 -276) translate(657 276)"
        />
      </g>
      <path
        d="M95.865 72.483c3.92-1.514 6.497-5.195 6.502-9.294v-2.165c-.005-4.098-2.581-7.78-6.502-9.294l-5.48-2.075V35.218c-.006-.301-.166-.58-.427-.744-.262-.163-.59-.188-.874-.068L54.434 51.28H39.852c-5.644 0-10.218 4.444-10.218 9.925v2.797c0 5.482 4.574 9.926 10.218 9.926h.929v19.128h1.858V73.927h11.797L88.99 90.709h.929c.297-.166.476-.479.464-.812V74.558l5.48-2.075zM31.49 64.001v-2.797c0-4.484 3.744-8.12 8.36-8.12h13.935v19.038H39.85c-4.617 0-8.36-3.636-8.36-8.12zm57.036 24.453L55.643 72.483v-19.76l32.883-15.97v51.7zm6.689-34.92c3.192 1.207 5.32 4.164 5.387 7.49v2.165c-.03 3.36-2.164 6.362-5.387 7.58l-4.83 1.804V51.64l4.83 1.895z"
        transform="translate(-657 -276) translate(657 276)"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  name: "icon-add",
  components: {},
})
export class IconAlerta extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;

  constructor() {
    super();
  }
}
export default IconAlerta;
</script>
